const isDev = process.env.NODE_ENV === 'development';

export const AUTH_URL = 'https://api.synthetica.ai';
export const LOCAL_URL = 'https://localhost:8080';
export const BASE_URL = isDev ? 'http://localhost:5000/ddcost' : 'https://api.synthetica.ai/ddcost';
